/**
 * Placeholder palette. These are neutral starting values, not the Hour of AI
 * brand — replace them when the design lands. They exist so the theme is a real
 * theme from day one rather than silently falling back to Code.org's.
 */
export const COLORS = {
  black: '#141414',
  white: '#FFF',
  brandPrimary: '#1F1976',
  brandSecondary: '#0099F3',
  brandTertiary: '#34BD43',
  backgroundPrimary: '#FFF',
  grey200: '#E4E6E9',
};
